import { GetBulkAppointmentsParams } from "../../utils/bridges/DummyBridge";
import getB from "../../utils/bridges/EkaBridge";

export const bulkGetAppointments = async (params: GetBulkAppointmentsParams) => {
  return await getB().appointmentsV2.getBulkAppointments(params);
};
